import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import PaidIcon from "@mui/icons-material/Paid";
import SavingsIcon from "@mui/icons-material/Savings";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import MoneyOffIcon from "@mui/icons-material/MoneyOff";
import MoneyIcon from "@mui/icons-material/Money";

import { Options } from "../../components/Select";

export const CARDS = [
  {
    id: "balance",
    name: "Balance",
    color: "var(--color-info)",
    icon: <ImportExportIcon />,
    value: 0,
    path: "/transactions",
  },
  {
    id: "income",
    name: "Income",
    color: "var(--color-success)",
    icon: <ArrowUpwardIcon />,
    value: 0,
    path: "/transactions",
    type: "Income",
  },
  {
    id: "expenses",
    name: "Expenses",
    color: "var(--color-error)",
    icon: <ArrowDownwardIcon />,
    value: 0,
    path: "/transactions",
    type: "Expense",
  },
  {
    id: "accounts",
    name: "Accounts",
    color: "var(--color-info)",
    icon: <AccountBalanceWalletIcon />,
    value: 0,
    path: "/accounts",
  },
  {
    id: "savings",
    name: "Savings",
    color: "var(--color-purple)",
    icon: <SavingsIcon />,
    value: 0,
    path: "/savings",
  },
  {
    id: "investments",
    name: "Investments",
    color: "var(--color-blue)",
    icon: <PaidIcon />,
    value: 0,
    path: "/investments",
  },
  {
    id: "liabilities",
    name: "Liabilities",
    color: "var(--color-warning)",
    icon: <MoneyOffIcon />,
    value: 0,
    path: "/liabilities",
  },
  {
    id: "netWorth",
    name: "Net Worth",
    color: "var(--color-success)",
    icon: <MoneyIcon />,
    value: 0,
    path: null,
  },
];

export const MANUAL_INVESTMENTS_EXCLUDED_TOOLTIP =
  "Manual investment accounts aren't included.";

export const MONTH_OPTIONS = [
  { label: "Jan", value: 1 },
  { label: "Feb", value: 2 },
  { label: "Mar", value: 3 },
  { label: "Apr", value: 4 },
  { label: "Mai", value: 5 },
  { label: "Jun", value: 6 },
  { label: "Jul", value: 7 },
  { label: "Aug", value: 8 },
  { label: "Sep", value: 9 },
  { label: "Out", value: 10 },
  { label: "Nov", value: 11 },
  { label: "Dez", value: 12 },
] as Options[];
